// Cannot use rankingsEntity type due to circular dependency issue
export const sortProjection = (p: { projection?: { points?: { mid: number } } }) => {
  if (!p?.projection?.points?.mid) {
    return -1
  }

  return p.projection.points.mid
}
